import { loginModalType } from "./loginModalType";

const loginModalShow = () => ({ type: loginModalType.LOGIN_MODAL_SHOW });
const loginModalHide = () => ({ type: loginModalType.LOGIN_MODAL_HIDE });

export { loginModalShow, loginModalHide };